import api from "@/api/client";

const BASE = "/app-access";

/** @param {{ reason: string, startsAt: string, endsAt: string }} dto */
export async function disableDistrict(dto) {
  const { data } = await api.post(`${BASE}/district`, dto);
  return data;
}

/** @param {{ revokeReason: string }} dto */
export async function revokeDistrict(dto) {
  const { data } = await api.delete(`${BASE}/district`, { data: dto });
  return data;
}

/** @param {{ reason: string, startsAt: string, endsAt: string }} dto */
export async function updateDistrict(dto) {
  const { data } = await api.patch(`${BASE}/district`, dto);
  return data;
}

export async function fetchDistrictActive() {
  const { data } = await api.get(`${BASE}/district/active`);
  return data;
}

export async function fetchDistrictHistory() {
  const { data } = await api.get(`${BASE}/district/history`);
  return data;
}

/** @param {{ reason: string, startsAt: string, endsAt: string }} dto */
export async function disableSchool(dto) {
  const { data } = await api.post(`${BASE}/school`, dto);
  return data;
}

/** @param {{ revokeReason: string }} dto */
export async function revokeSchool(dto) {
  const { data } = await api.delete(`${BASE}/school`, { data: dto });
  return data;
}

/** @param {{ reason: string, startsAt: string, endsAt: string }} dto */
export async function updateSchool(dto) {
  const { data } = await api.patch(`${BASE}/school`, dto);
  return data;
}

export async function fetchSchoolActive() {
  const { data } = await api.get(`${BASE}/school/active`);
  return data;
}

export async function fetchSchoolHistory() {
  const { data } = await api.get(`${BASE}/school/history`);
  return data;
}
